module.exports = __webpack_public_path__ + "img/00042.6c0b5af1.webp";